/**
 * Created by Shikha on 2021-12-08.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {Oktoberfest} from "../../Oktoberfest";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {OktoberfestSymbol} from "../../symbol/OktoberfestSymbol";
import {TimelineLite} from "gsap";
import {OktoberfestSound} from "../../sound/OktoberfestSound";

export class PretzelPartyController extends ReelStopPresentationController {

    private _animations: TimelineLite[] = [];
    private _isPartySpin: boolean = false;
    private _partySymbol: string = "";
    private _isPretzelParty: boolean = false;

    constructor() {
        super("PretzelParty");
    }

    public skip(): void {
        super.skip();
        OktoberfestSound.soundPlayer.stopTrack(OktoberfestSound.SOUND_NAME_PM_TURN_INTO_WILD);
        OktoberfestSound.soundPlayer.stopTrack(OktoberfestSound.SOUND_NAME_PM_MARCHING_DRUM);
        //Oktoberfest.partyMode.fadeAmbience(0, 0);

        /*
            This skip function is always called when you do a quickstop, regardless if the feature is active or not.
            For some reason, this music fade does nothing when just quicstopping normally, but if you switch tab in the browser, this fade actually takes place.
            Causing the volume to be set to 0. Once the player returns to the game tab the sound is unpaused, but the volume is set to 0 so there is no music.
            The sound should be brought back once "allReelsStopped" in OktoberFestPartyView, but it's not.

            I'm not familiar with this implementation to understand why that is. But by removing this line the sound issue is fixed.
            And I don't notice any difference in behaviour when quickstopping the feature either.
        */


        Oktoberfest.partyMode.isSkipped = true;
        Oktoberfest.partyMode.onQuickStopStoppingSpin();
        this._animations.forEach(a => a.timeScale(2));
    }

    // override this with real animation.
    protected async onReelStopped(data: IReelStateEventData): Promise<any> {
        this._isPartySpin = Oktoberfest.model.parsedGameData.mode == "STACKED_PARTY_SPIN";
        this._partySymbol = this._isPartySpin ? Oktoberfest.model.parsedGameData.stackedModeSymbol : "";
        this._isPretzelParty = this._isPartySpin && this._partySymbol === "W";
        const promises: Promise<any>[] = [];
        const symbols: OktoberfestSymbol[] = [];
        let count: number = 0;
        if (this._isPretzelParty) {
            Oktoberfest.model.parsedGameData.overlayWilds[data.reelId].forEach((symName, symIndex) => {
                if (symName === "W") {
                    count++;
                    const symbol: OktoberfestSymbol = Oktoberfest.reels[data.reelId].getSymbol(symIndex);
                    symbols.push(symbol);
                    const tween: TimelineLite = new TimelineLite();
                    tween.add([symbol.lowSymAnimation(), () => {
                        OktoberfestSound.playSoundEffect(OktoberfestSound.SOUND_NAME_PM_TURN_INTO_WILD);
                    }], count * 0.5);

                    if (this.isSkip) {
                        tween.timeScale(2);
                    }
                    tween.add((() => {
                    }), tween.totalDuration() + 0.5);
                    this._animations.push(tween);
                    promises.push(Promise.resolve(tween).then(res => {
                        Oktoberfest.reels[data.reelId].replaceSimpleSymbol(symIndex, "W");
                        ArrayHelper.removeFirstMatchElement(this._animations, tween);
                    }));
                }
            });
        }
        await Promise.all(promises);
        symbols.length = 0;
        await new Promise<void>(resolve => {
            this.blinkingAnimation(data.reelId, resolve);
        });
        return super.onReelStopped(data);
    }

    private blinkingAnimation(reelId: number, resolve: () => void): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                resolve();
            }
        });
        if (Oktoberfest.model.parsedGameData.stackedModeSymbol === "W") {
            tl.add(Oktoberfest.pretzelPartyView.playBlinkAnimations(reelId));
        } else {
            tl.to(this, {duration: 0.1});
        }
        return tl;
    }
}
